<template>
  <div>
    <button
      class="service-float"
      type="button"
      title="联系客服"
      @click="visible = true"
    >
      <i class="service-float__icon" aria-hidden="true">
        <IconSymbol name="headset" />
        <b></b>
      </i>
      <span>在线客服</span>
    </button>
    <transition name="service-pop">
      <div v-if="visible" class="service-mask" @click.self="visible = false">
        <section class="service-modal" role="dialog" aria-modal="true" aria-labelledby="service-title">
          <button class="site-modal-close" type="button" aria-label="关闭客服弹窗" @click="visible = false">×</button>

          <header class="service-head">
            <span class="service-avatar" aria-hidden="true">
              <IconSymbol name="headset" />
              <i></i>
            </span>
            <div>
              <h3 id="service-title">联系我们</h3>
              <p>扫码 · 在线咨询</p>
            </div>
          </header>

          <div class="qr-shell">
            <div class="qr">
              <img src="../assets/kefu.jpg" alt="Paper智创客服二维码" />
            </div>
          </div>

          <div class="scan-label">
            <IconSymbol name="qrcode" />
            <span>微信扫码联系客服</span>
          </div>

          <a
            class="online-service"
            href="https://work.weixin.qq.com/kfid/kfc121ee95b54b39063"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconSymbol name="headset" />
            <strong>联系在线客服</strong>
            <span aria-hidden="true">↗</span>
          </a>

          <p class="service-note">订单、充值、兑换码及生成问题均可咨询</p>
        </section>
      </div>
    </transition>
  </div>
</template>
<script>
import IconSymbol from "./IconSymbol.vue";
export default {
  name: "CustomerService",
  components: { IconSymbol },
  data: () => ({ visible: false }),
};
</script>
<style scoped>
.service-float {
  position: fixed;
  right: 24px;
  bottom: 28px;
  z-index: 60;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 72px;
  height: 72px;
  border: 1px solid #cfdef1;
  border-radius: 22px;
  color: #3d72b7;
  background: linear-gradient(145deg, #ffffff 12%, #edf5ff 100%);
  box-shadow: none;
  transition: color .18s ease, border-color .18s ease, background .18s ease, transform .18s ease;
}
.service-float:hover {
  border-color: #aac8ed;
  color: #3265a7;
  background: linear-gradient(145deg, #f9fcff 12%, #e3f0ff 100%);
  transform: translateY(-2px);
}
.service-float:focus-visible {
  outline: 3px solid rgba(96, 153, 242, .2);
  outline-offset: 3px;
}
.service-float__icon {
  position: relative;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(145deg, #6da6f1, #3f82e8);
  font-style: normal;
}
.service-float__icon .icon-symbol {
  width: 19px;
  height: 19px;
}
.service-float__icon b {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 10px;
  height: 10px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #28b989;
}
.service-float > span {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}
.service-mask {
  position: fixed;
  inset: 0;
  z-index: 75;
  background: rgba(22, 36, 58, 0.12);
}
.service-modal {
  position: absolute;
  right: 24px;
  bottom: 112px;
  width: min(388px, calc(100vw - 48px));
  padding: 24px 24px 20px;
  border: 1px solid #dce8f6;
  border-radius: 22px;
  background: #fff;
  text-align: center;
  box-shadow: 0 24px 64px rgba(29, 55, 91, 0.2);
}
.service-modal::before {
  position: absolute;
  top: 0;
  right: 18px;
  left: 18px;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, #6099f2, #48b8dd, #39b7a3);
  content: "";
}
.service-modal::after {
  position: absolute;
  right: 28px;
  bottom: -9px;
  width: 18px;
  height: 18px;
  border-right: 1px solid #dce8f6;
  border-bottom: 1px solid #dce8f6;
  background: #fff;
  content: "";
  transform: rotate(45deg);
}
.service-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 48px;
  text-align: left;
}
.service-avatar {
  position: relative;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(145deg, #6099f2, #3f82e8);
  box-shadow: 0 10px 20px rgba(63, 130, 232, 0.25);
}
.service-avatar i {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 13px;
  height: 13px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #22c55e;
}
.service-head h3 {
  margin: 0;
  color: #1b2f4e;
  font-size: 20px;
  line-height: 1.35;
}
.service-head p {
  margin: 3px 0 0;
  color: #7b899e;
  font-size: 12px;
}
.qr-shell {
  width: 226px;
  margin: 20px auto 0;
  padding: 10px;
  border: 1px solid #e1eaf5;
  border-radius: 18px;
  background: #f5f8fc;
}
.qr {
  width: 204px;
  height: 204px;
  overflow: hidden;
  border-radius: 11px;
  background: #fff;
}
.qr img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.scan-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 10px;
  color: #587196;
  font-size: 13px;
}
.scan-label .icon-symbol {
  width: 17px;
  height: 17px;
  color: #4d8be6;
}
.online-service {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 44px;
  margin-top: 18px;
  padding: 0 18px;
  border-radius: 999px;
  color: #fff;
  background: linear-gradient(110deg, #4f8dea, #6099f2);
  box-shadow: 0 10px 22px rgba(63, 130, 232, 0.23);
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.online-service:hover {
  color: #fff;
  box-shadow: 0 14px 28px rgba(63, 130, 232, 0.3);
  transform: translateY(-1px);
}
.online-service .icon-symbol {
  width: 18px;
  height: 18px;
}
.online-service > span:last-child {
  font-size: 15px;
}
.service-note {
  margin: 12px 0 0;
  color: #8a97aa;
  font-size: 12px;
}
.service-pop-enter-active,
.service-pop-leave-active {
  transition: opacity 0.2s ease;
}
.service-pop-enter-active .service-modal,
.service-pop-leave-active .service-modal {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.service-pop-enter,
.service-pop-leave-to {
  opacity: 0;
}
.service-pop-enter .service-modal,
.service-pop-leave-to .service-modal {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
@media (max-width: 900px) {
  .service-float {
    display: none !important;
  }
  .service-float__icon {
    width: 34px;
    height: 34px;
  }
  .service-modal {
    right: 12px;
    bottom: 88px;
    width: min(376px, calc(100vw - 24px)) !important;
    padding: 22px 20px 18px;
  }
  .qr-shell {
    width: 202px;
  }
  .qr {
    width: 180px !important;
    height: 180px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .service-float,
  .online-service,
  .service-pop-enter-active,
  .service-pop-leave-active,
  .service-pop-enter-active .service-modal,
  .service-pop-leave-active .service-modal {
    transition: none;
  }
}
</style>
